import { ProductRenderer } from '../ProductRenderer';
import { Mouse } from './Mouse';

export class CursorHandler {
	constructor(private renderer: ProductRenderer, private mouse: Mouse) {}

	setCursorType() {}
}
